import { render, staticRenderFns } from "./SectionBlogLandowners.vue?vue&type=template&id=0b2ae2d2&"
import script from "./SectionBlogLandowners.vue?vue&type=script&lang=js&"
export * from "./SectionBlogLandowners.vue?vue&type=script&lang=js&"
import style0 from "./SectionBlogLandowners.vue?vue&type=style&index=0&id=0b2ae2d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports